import { render } from "./HomeServices.vue?vue&type=template&id=ef6d2bb0&scoped=true"
import script from "./HomeServices.vue?vue&type=script&lang=js"
export * from "./HomeServices.vue?vue&type=script&lang=js"

import "./HomeServices.vue?vue&type=style&index=0&id=ef6d2bb0&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6d2bb0"]])

export default __exports__